import marketingImage from 'common/assets/images/empty-state/implement-banner-thumbnail.png';

import {SvgIconType} from '../svg-icon/types';
import {BannerTheme} from './types';

export const NO_ICON = `no-icon`;
const TRACK_BANNER_SHOWN_EVENT_NAME = `[mp-banner] Banner Shown`;
const ICON_FROM_THEME = new Map<BannerTheme, SvgIconType>([
  [BannerTheme.Base, `idea`],
  [BannerTheme.Error, `warning`],
  [BannerTheme.Info, `info`],
  [BannerTheme.InfoBlue, `event-sampling`],
  [BannerTheme.Success, `circle-checkmark`],
  [BannerTheme.Warn, `warning`],
]);

const IMAGE_FROM_THEME = new Map<BannerTheme, string>([[BannerTheme.Marketing, marketingImage]]);

/**
 * Retrieves the correct icon to display for the given component.
 */
export function getIcon(icon?: string, theme?: string): SvgIconType | null | undefined {
  if (icon === NO_ICON) {
    return null;
  }
  return icon === `from-theme` ? ICON_FROM_THEME.get(theme as BannerTheme) : (icon as SvgIconType);
}

/**
 * Retrieves the correct image to display for the given component.
 */
export function getImage(imgSrc?: string, theme?: string): string | undefined {
  return imgSrc || IMAGE_FROM_THEME.get(theme as BannerTheme);
}

/**
 * Creates a `track` event for the given component.
 */
export function createBannerShownEventFor(
  bodyText: string | undefined,
  bannerTrackingType: string | undefined,
): CustomEvent {
  return new CustomEvent(`track`, {
    bubbles: true,
    composed: true,
    cancelable: true,
    detail: {
      eventName: TRACK_BANNER_SHOWN_EVENT_NAME,
      props: {
        'Banner Type': bannerTrackingType || bodyText,
        'Banner Message': bodyText,
      },
    },
  });
}
